import { useState } from 'react';
import { Modal, Button, Form, Row, Col, InputGroup, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { api } from '../../../../services/api';
import { useMisc } from '../../../../contexts/MiscContext';
import { useChamadosSourcingContext } from '../pa_chamados_sourcing_context';
import styles from '../pa_chamados_sourcing.module.scss';
import { formatarCNPJ, formatarTelefone, limparTelefone } from '../../../../utils/misc_utils';
import CookiesService from '../../../../services/cookies';
import { listaBool, listaUnidadesFederativas } from './pa_chamados_sourcing_options';

const ModalNovoChamado = () => {
  const { showModalNovoChamado, setShowModalNovoChamado, tipoFormulario, setTipoFormulario, carregarChamados } = useChamadosSourcingContext();
  const { setShowLoading } = useMisc();
  const [carregandoProduto, setCarregandoProduto] = useState(false);
  const [produtoSelecionado, setProdutoSelecionado] = useState('');
  const [carregandoFornecedor, setCarregandoFornecedor] = useState(false);
  const [cnpjFornecedorSelecionado, setCnpjFornecedorSelecionado] = useState(false);
  const [formulario, setFormulario] = useState({
    responsavel: CookiesService.getUserLogin(),
    email_responsavel: '',
    tipo_amostra: null,
    tipo_produto: null,
    numero_lacre_envio: '',
    referencia_produto: '',
    piloto_enviada: null,
    lacre_producao_piloto: '',
    ficha_tecnica_enviada: null,
    cnpj_fornecedor: '',
    cnpj_fornecedor_principal: '',
    nome_fantasia_fornecedor: '',
    nome_fantasia_fornecedor_principal: '',
    tipo_fornecedor: null,
    possui_corte: null,
    capacidade_total: '',
    estimativa_capacidade: '',
    uf: null,
    nicho_atuacao: '',
    maquinarios: '',
    restricoes: '',
    observacoes: '',
    email_contato: '',
    nome_contato: '',
    telefone_contato: ''
  });

  const keyToErr = {
    tipo_amostra: 'Tipo de Amostra',
    tipo_produto: 'Tipo de Produto',
    numero_lacre_envio: 'Número do Lacre Envio',
    referencia_produto: 'Referência do Produto',
    piloto_enviada: 'Piloto Enviada',
    lacre_producao_piloto: 'Lacre Produção Piloto',
    ficha_tecnica_enviada: 'Ficha Tecnica Enviada',
    cnpj_fornecedor: 'CNPJ Fornecedor',
    cnpj_fornecedor_principal: 'CNPJ Fornecedor Principal',
    nome_fantasia_fornecedor_principal: 'Nome Fantasia',
    tipo_fornecedor: 'Tipo Fornecedor',
    possui_corte: 'Possui Corte',
    capacidade_total: 'Capacidade Total',
    estimativa_capacidade: 'Estimativa de Capacidade',
    uf: 'UF',
    email_contato: 'Email de Contato',
    nome_contato: 'Nome e Sobrenome p/ Contato',
    telefone_contato: 'Telefone de Contato',
    ref_diferente: 'Referência selecionada difere da inserida',
    cnpj_diferente: 'CNPJ selecionado difere do inserido'
  }

  const [listaTipoFornecedor] = useState([
    { value: 'Confecção', label: 'Confecção' },
    { value: 'Facção', label: 'Facção' }
  ]);

  const [listaTipoAmostra] = useState([
    { value: 'Malhas', label: 'Malhas' },
    { value: 'Tecidos planos', label: 'Tecidos planos' },
    { value: 'Jeans e sarja', label: 'Jeans e sarja' },
    { value: 'Seda e tecidos leves', label: 'Seda e tecidos leves' },
    { value: 'Alfaiataria', label: 'Alfaiataria' }
  ]);

  const [listaTipoProduto] = useState([
    {value: 'Bottom', label: 'Bottom'},
    {value: 'Top', label: 'Top'},
    {value: 'Overtop', label: 'Overtop'},
    {value: 'Camisaria', label: 'Camisaria'},
    {value: 'Inteiros', label: 'Inteiros'},
    {value: 'Infantil', label: 'Infantil'},
    {value: 'Lingerie', label: 'Lingerie'},
    {value: 'Moda praia', label: 'Moda praia'}
  ]);

  const [dadosProduto, setDadosProduto] = useState({});

  const handleChange = (campo, valor) => {
    setFormulario(prev => ({ ...prev, [campo]: valor }));
  }

  const handleChangeCnpj = (campo, valor) => {
    const upVal = valor.replace(/[./-]/g, '')
    setFormulario(prev => ({ ...prev, [campo]: upVal }));
  }

  const validarFormulario = () => {
    const errs = [];
    const obrigatoriosEnvioAnalise = [
      'responsavel',
      'email_responsavel',
      'tipo_amostra',
      'tipo_produto',
      'numero_lacre_envio',
      'piloto_enviada',
      'referencia_produto'
    ];
    for (const key of obrigatoriosEnvioAnalise) if (formulario[key] === null || formulario[key] === '') errs.push(key);
    if (formulario.piloto_enviada?.value && (!formulario.lacre_producao_piloto || formulario.lacre_producao_piloto === '')) {
      errs.push('lacre_producao_piloto');
    }
    if (produtoSelecionado !== formulario.referencia_produto) errs.push('ref_diferente');
    if (cnpjFornecedorSelecionado !== formulario.cnpj_fornecedor && tipoFormulario === 102) {
      errs.push('cnpj_diferente');
    }

    const obrigatoriosFornecedor = [
      'nome_fantasia_fornecedor_principal',
      'tipo_fornecedor',
      'possui_corte',

      'capacidade_total',
      'uf',

      'email_contato',
      'nome_contato',
      'telefone_contato'
    ];

    if (formulario.cnpj_fornecedor_principal.length !== 14) errs.push('cnpj_fornecedor_principal');
    for (const key of obrigatoriosFornecedor) if (formulario[key] === null || formulario[key] === '') errs.push(key);

    if (tipoFormulario === 101) if (!formulario.estimativa_capacidade) errs.push('estimativa_capacidade');
    if (tipoFormulario === 102) if (formulario.cnpj_fornecedor.length !== 14) errs.push('cnpj_fornecedor');

    return errs;
  }

  const processarNovoChamado = async () => {
    try {
      setShowLoading(true);

      const errs = validarFormulario();
      if (errs.length > 0) return toast.warning(
        <div>
          {errs.length > 0 &&  'Por favor revise os campos a seguir:'}
          {errs.map((err, i) => <div key={`err_${i}`}>{keyToErr[err]}</div>)}
          {errs.includes('ref_diferente') && 'Campo Referência de Produto divergente'}
        </div>
      );

      const params = {
        id_responsavel: CookiesService.getUserId(),
        tipo_formulario: tipoFormulario,
        ...formulario
      }

      await api.post('pa/chamados-sourcing/criar-novo-chamado', params);
      await carregarChamados(true);
      fecharModal();
    } catch (e) {
      toast.error('Houve um problema durante a abertura do chamado. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const buscarDadosProduto = async () => {
    try {
      setCarregandoProduto(true);
      setProdutoSelecionado(formulario.referencia_produto);
      const res = await api.get('pa/chamados-sourcing/get-dados-produto', { params: { produto: formulario.referencia_produto } });
      setDadosProduto({ ...res.data });
    } catch (e) {
      toast.error('Ocorreu um erro ao buscar os dados do produto. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setCarregandoProduto(false);
    }
  }

  const buscarDadosFornecedor = async () => {
    try {
      setCarregandoFornecedor(true);
      const res = await api.get('pa/chamados-sourcing/get-dados-fornecedor', { params: { cnpj_fornecedor: formulario.cnpj_fornecedor } });
      if (res.data[0] === 50069) return toast.warn('Fornecedor principal não encontrado, for favor confirme o CNPJ inserido.');
      setFormulario({
        ...formulario,
        nome_fantasia_fornecedor: res.data.fornecedor,
        nome_fantasia_fornecedor_principal: res.data.fornecedor_principal,
        cnpj_fornecedor_principal: res.data.cnpj_fornecedor_principal,
        uf: listaUnidadesFederativas().find(item => item.value === res.data.uf),
        capacidade_total: res.data.capacidade_total
      });
      setCnpjFornecedorSelecionado(formulario.cnpj_fornecedor);
    } catch (e) {
      toast.error('Ocorreu um erro ao buscar os dados do produto. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setCarregandoFornecedor(false);
    }
  }

  const customSelectStyles = {
    control: provided => ({
      ...provided,
      minHeight: '32px',
      height: '32px',
      maxHeight: '32px',
      border: '1px solid #dee2e6',
      boxShadow: 'none',
      lineHeight: '1.5'
    }),
    valueContainer: provided => ({
      ...provided,
      height: '32px',
      padding: '0 6px',
      lineHeight: '1.5'
    }),
    input: provided => ({
      ...provided,
      margin: '0px',
      padding: '0px',
      lineHeight: '1.5'
    }),
    indicatorsContainer: provided => ({
      ...provided,
      height: '32px',
      lineHeight: '1.5'
    }),
  }

  const required = () => {
    return <span style={{ color: 'red' }}>*</span>;
  }

  const fecharModal = () => {
    setProdutoSelecionado('');
    setTipoFormulario(null);
    setShowModalNovoChamado(false);
  }

  return (
    <Modal
      show={showModalNovoChamado}
      onHide={fecharModal}
      size="xl"
      backdrop="static"
      fullscreen='lg-down'
    >
      <Modal.Header closeButton>
        <Modal.Title>Novo Chamado</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p><strong>Tipo:</strong> Sourcing - Qualidade PA</p>
        <p>
          <strong>Categoria do Chamado:</strong> Solicitação de Análise Qualidade PA - {tipoFormulario === 101 ? 'Novo Fornecedor' : 'Fornecedor Atual Desenvolvimento'}
        </p>
        {/* <p><strong>Situação do Chamado:</strong> <span className="text-danger">Novo</span></p> */}
        <p><strong>Atribuído para:</strong> <span className="text-danger">qualidade.assistente</span></p>
        <hr />

        <h5 className="mt-4">DADOS DE ENVIO DE ANÁLISE</h5>
        <Form>
          <Row className="mb-3">
            {/* <Col md={3}>
              <Form.Group>
                <Form.Label>Data de Envio da amostra</Form.Label>
                <Form.Control
                  type="date"
                  style={{ height: '32px' }}
                  value={formulario.data_envio_amostra}
                  onChange={e => handleChange('data_envio_amostra', e.target.value)}
                />
              </Form.Group>
            </Col> */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Responsável Sourcing</Form.Label>
                <Form.Control
                  disabled
                  value={formulario.responsavel}
                  style={{ height: '32px' }}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Email Responsável Sourcing {required()}</Form.Label>
                <Form.Control
                  type="email"
                  style={{ height: '32px' }}
                  value={formulario.email_responsavel}
                  onChange={e => handleChange('email_responsavel', e.target.value)}
                  placeholder='exemplo@somagrupo.com.br'
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>Tipo de Amostra {required()}</Form.Label>
                <Select
                  styles={customSelectStyles}
                  value={formulario.tipo_amostra}
                  onChange={e => handleChange('tipo_amostra', e)}
                  options={listaTipoAmostra}
                  placeholder={'Selecionar'}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Tipo de Produto {required()}</Form.Label>
                <Select
                  styles={customSelectStyles}
                  value={formulario.tipo_produto}
                  onChange={e => handleChange('tipo_produto', e)}
                  options={listaTipoProduto}
                  placeholder={'Selecionar'}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Número do Lacre Envio {required()}</Form.Label>
                <Form.Control
                  style={{ height: '32px' }}
                  value={formulario.numero_lacre_envio}
                  onChange={e => handleChange('numero_lacre_envio', e.target.value)}
                  placeholder={'Ex: 01.0082'}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Referência do Produto {required()} |<span className={styles.prod_value}>{produtoSelecionado || '-'}</span>
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    style={{ height: '32px' }}
                    value={formulario.referencia_produto}
                    onChange={e => handleChange('referencia_produto', e.target.value)}
                    placeholder="Ex: 346601"
                    isInvalid={produtoSelecionado !== formulario.referencia_produto}
                  />
                  <Button
                    variant="outline-secondary"
                    style={{ height: '32px' }}
                    onClick={buscarDadosProduto}
                    disabled={carregandoProduto}
                  >
                    {carregandoProduto ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      'Buscar'
                    )}
                  </Button>
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>Piloto Enviada {required()}</Form.Label>
                <Select
                  styles={customSelectStyles}
                  value={formulario.piloto_enviada}
                  onChange={e => handleChange('piloto_enviada', e)}
                  options={listaBool()}
                  placeholder='Selecionar'
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Lacre Produção Piloto {formulario.piloto_enviada?.value === true && required()}
                </Form.Label>
                <Form.Control
                  style={{ height: '32px' }}
                  value={formulario.lacre_producao_piloto}
                  onChange={e => handleChange('lacre_producao_piloto', e.target.value)}
                  disabled={!formulario.piloto_enviada?.value}
                  placeholder='Ex: 000010'
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Ficha Técnica Enviada {required()}</Form.Label>
                <Select
                  styles={customSelectStyles}
                  value={formulario.ficha_tecnica_enviada}
                  onChange={e => handleChange('ficha_tecnica_enviada', e)}
                  options={listaBool()}
                  placeholder='Selecionar'
                />
              </Form.Group>
            </Col>
          </Row>

          <hr />

          <Row className="mb-3">
            <Col md={6}>
              <label>Marca |</label>
              <span className={styles.prod_value}>{dadosProduto.marca || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Descrição do Produto |</label>
              <span className={styles.prod_value}>{dadosProduto.desc_produto || '-'}</span>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <label>Linha |</label>
              <span className={styles.prod_value}>{dadosProduto.linha || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Grupo |</label>
              <span className={styles.prod_value}>{dadosProduto.grupo_produto || '-'}</span>
            </Col>
          </Row>

          <Row className="mb-3">
            {/* <Col md={4}>
              <label>Data Fim Lacre |</label>
              <span className={styles.prod_value}>{dadosProduto.dataFimLacre || '-'}</span>
            </Col> */}
            <Col md={6}>
              <label>Composição |</label>
              <span className={styles.prod_value}>{dadosProduto.desc_composicao || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Status do Produto (Lacre) |</label>
              <span className={styles.prod_value}>{dadosProduto.status_lacre_atual || '-'}</span>
            </Col>
          </Row>

          <hr />

          <Row className="mb-3">
            <Col md={6}>
              <label>Última Movimentação Linx |</label>
              <span className={styles.prod_value}>{dadosProduto.data_movimentacao || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Data Piloto Lacrada Linx |</label>
              <span className={styles.prod_value}>{dadosProduto.data_aprovacao || '-'}</span>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <label>Estoque Atual PLM |</label>
              <span className={styles.prod_value}>{dadosProduto.estoque_destino || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Localização PLM |</label>
              <span className={styles.prod_value}>{dadosProduto.localizacao || '-'}</span>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <label>Data Piloto PLM |</label>
              <span className={styles.prod_value}>{dadosProduto.data_piloto_plm || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Grau de Dificuldade da Peça |</label>
              <span className={styles.prod_value}>{dadosProduto.grau_dif_pos_provao || '-'}</span>
            </Col>
          </Row>

          <hr />

          <h5 className="mt-4">
            {tipoFormulario === 101 ? 'DADOS DO NOVO FORNECEDOR' : 'DADOS FORNECEDOR ATUAL'}
          </h5>
          {
            tipoFormulario === 102 &&
            <Row className='mb-3'>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>CNPJ Fornecedor {required()}</Form.Label>
                  <InputGroup>
                    <Form.Control
                      style={{ height: '32px' }}
                      value={formatarCNPJ(formulario.cnpj_fornecedor)}
                      onChange={e => handleChangeCnpj('cnpj_fornecedor', e.target.value)}
                      placeholder="00.000.000/0000-00"
                      isInvalid={cnpjFornecedorSelecionado !== formulario.cnpj_fornecedor}
                    />
                    <Button
                      variant="outline-secondary"
                      style={{ height: '32px' }}
                      onClick={buscarDadosFornecedor}
                      disabled={carregandoFornecedor}
                    >
                      {carregandoFornecedor ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        'Buscar'
                      )}
                    </Button>
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={4}>
              <Form.Group>
                <Form.Label>Nome Fantasia Fornecedor {required()}</Form.Label>
                <Form.Control
                  style={{ height: '32px' }}
                  value={formulario.nome_fantasia_fornecedor}
                  onChange={e => handleChange('nome_fantasia_fornecedor', e.target.value)}
                  disabled
                  placeholder='Nome fantasia'
                />
              </Form.Group>
            </Col>
            </Row>
          }

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>CNPJ Fornecedor Principal {required()}</Form.Label>
                <Form.Control
                  style={{ height: '32px' }}
                  value={formatarCNPJ(formulario.cnpj_fornecedor_principal)}
                  onChange={e => handleChangeCnpj('cnpj_fornecedor_principal', e.target.value)}
                  placeholder="00.000.000/0000-00"
                  disabled={tipoFormulario === 102}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>
                  {tipoFormulario === 102 ? 'Nome Fantasia Fornecedor Principal' : 'Nome Fantasia Fornecedor'}&nbsp;{required()}
                </Form.Label>
                <Form.Control
                  style={{ height: '32px' }}
                  value={formulario.nome_fantasia_fornecedor_principal}
                  onChange={e => handleChange('nome_fantasia_fornecedor_principal', e.target.value)}
                  disabled={tipoFormulario === 102}
                  placeholder='Nome fantasia'
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Tipo Fornecedor {required()}</Form.Label>
                <Select
                  styles={customSelectStyles}
                  value={formulario.tipo_fornecedor}
                  onChange={e => handleChange('tipo_fornecedor', e)}
                  options={listaTipoFornecedor}
                  placeholder='Selecionar'
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>Possui Corte {required()}</Form.Label>
                <Select
                  styles={customSelectStyles}
                  value={formulario.possui_corte}
                  onChange={e => handleChange('possui_corte', e)}
                  options={listaBool()}
                  placeholder='Selecionar'
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  {tipoFormulario === 102 ? 'Capacidade Produtiva Soma' : 'Capacidade Total Produtiva'} {required()}
                </Form.Label>
                <Form.Control
                  style={{ height: '32px' }}
                  value={formulario.capacidade_total}
                  onChange={e => handleChange('capacidade_total', e.target.value)}
                  disabled={tipoFormulario === 102}
                  placeholder='ex: 100'
                />
              </Form.Group>
            </Col>
            {
              tipoFormulario === 101 &&
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Estimativa Capacidade Soma {required()}</Form.Label>
                  <Form.Control
                    style={{ height: '32px' }}
                    value={formulario.estimativa_capacidade}
                    onChange={e => handleChange('estimativa_capacidade', e.target.value)}
                    disabled={tipoFormulario === 102}
                    placeholder={tipoFormulario === 102 ? 'N/A' : 'ex: 50'}
                  />
                </Form.Group>
              </Col>
            }
            <Col md={3}>
              <Form.Group>
                <Form.Label>UF {required()}</Form.Label>
                <Select
                  styles={customSelectStyles}
                  value={formulario.uf}
                  onChange={e => handleChange('uf', e)}
                  options={listaUnidadesFederativas()}
                  isDisabled={tipoFormulario === 102}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Nicho de Atuação</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={formulario.nicho_atuacao}
                  onChange={e => handleChange('nicho_atuacao', e.target.value)}
                  placeholder='Insira a lista de nichos de atuação aqui.'
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Maquinários Específicos</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={formulario.maquinarios}
                  onChange={e => handleChange('maquinarios', e.target.value)}
                  placeholder='Insira a lista de maquinários aqui.'
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Restrições</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={formulario.restricoes}
                  onChange={e => handleChange('restricoes', e.target.value)}
                  placeholder='Insira quaisquer restrições aqui.'
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Observações</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={formulario.observacoes}
                  onChange={e => handleChange('observacoes', e.target.value)}
                  placeholder='Insira suas observações aqui.'
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Email para Contato {required()}</Form.Label>
                <Form.Control
                  type="email"
                  style={{ height: '32px' }}
                  value={formulario.email_contato}
                  onChange={e => handleChange('email_contato', e.target.value)}
                  placeholder={'ex: joao@contato.com'}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Nome e Sobrenome p/ Contato {required()}</Form.Label>
                <Form.Control
                  style={{ height: '32px' }}
                  value={formulario.nome_contato}
                  onChange={e => handleChange('nome_contato', e.target.value)}
                  placeholder='ex: João da Silva'
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Telefone de Contato {required()}</Form.Label>
                <Form.Control
                  style={{ height: '32px' }}
                  value={formatarTelefone(formulario.telefone_contato)}
                  onChange={e => handleChange('telefone_contato', limparTelefone(e.target.value))}
                  placeholder='ex: (00) 00000-0000'
                  maxLength={15}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{ fontWeight: '500', width: '200px', marginRight: 'auto' }}
          variant="secondary"
          onClick={fecharModal}
        >
          Cancelar
        </Button>
        {/* <Button
          style={{ fontWeight: '500', width: '200px', marginRight: 'auto' }}
          variant="secondary"
          onClick={() => {
            if (tipoFormulario === 101) return setTipoFormulario(102);
            setTipoFormulario(101);
          }}
        >
          Teste Desenv. Tipo: {tipoFormulario}
        </Button> */}
        <Button
          style={{ fontWeight: '500', width: '200px' }}
          variant="success"
          onClick={processarNovoChamado}
        >
          Abrir Chamado
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalNovoChamado;
